const players = [
  {
    id: "01",
    Name: "Jay Jay Okocha",
    team: "Bolton",
    nationality: "Nigerian",
    jerseyNumber: 99,
    age: 28,
    imgURL:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTR6ivUEkeFGm1SzrSS6CeCX_PzhQnWi3DvsA&usqp=CAU",
  },
  {
    id: "02",
    Name: "Sergio Batista",
    team: "RealMadrid",
    nationality: "Germany",
    jerseyNumber: 66,
    age: 36,
    imgURL:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQckpi5YrWJbzsyfBx97HF5mEdyGNd0_Xlvey5unmdd&s",
  },
  {
    id: "03",
    Name: "Lionel Messi",
    team: "Bercelona",
    nationality: "Germany",
    jerseyNumber: 10,
    age: 26,
    imgURL:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2zWYZs1HfRBjV4vVUh2xugnWAAlWl4kV_vv2KXmNbTg&s",
  },
  {
    id: "04",
    Name: "Zenedi Zidane",
    team: "RealMadrid",
    nationality: "France",
    jerseyNumber: 5,
    age: 33,
    imgURL:
      "https://images2.minutemediacdn.com/image/fetch/w_2000,h_2000,c_fit/https%3A%2F%2Freddevilarmada.com%2Fwp-content%2Fuploads%2Fgetty-images%2F2017%2F07%2F467601014.jpeg",
  },
];
export const playerJSON = JSON.stringify(players);
